<script>
import layout from '@src/mixins/layout.vue'

export default {
  mixins: [layout],
}
</script>

<template>
  <v-footer
    :class="
      $store.state.nav.navDrawer && !notDesktop
        ? $style.shrinkFooterContainer
        : $style.footerContainer
    "
  >
    <v-row dense :class="$style.innerContainer">
      <v-col cols="12" md="12" sm="12" xs="12">
        <v-img
          width="130"
          height="30"
          contain
          left
          :src="require('@assets/images/footer/healthbook_white_logo.svg')"
        ></v-img>
      </v-col>
      <v-col cols="12" md="8" sm="8" xs="12">
        <div class="mb-2"
          >Your healthcare data, owned and managed by you, in a safe and secure
          platform.</div
        >
        <div class="mb-2 d-flex justify-space-between" :class="$style.links">
          <router-link
            class="mr-2 d-inline-flex"
            :to="{ name: 'healthbookplus-about' }"
            >About HB+</router-link
          >
          <router-link
            class="mr-2 d-inline-flex"
            :to="{ name: 'healthbookplus-privacy' }"
            >Privacy Policy</router-link
          >
          <router-link
            class="mr-2 d-inline-flex"
            :to="{ name: 'healthbookplus-terms' }"
            >Terms & Conditions</router-link
          >
        </div>
        <div class="mb-2 d-flex justify-space-between" :class="$style.links">
          <v-img
            class="mr-2 d-inline-flex"
            max-width="60"
            max-height="60"
            contain
            :src="require('@assets/images/footer/hipaa-seal-dark.png')"
          ></v-img>

          <v-img
            class="mr-2 d-inline-flex"
            max-width="60"
            max-height="60"
            contain
            :src="require('@assets/images/footer/Soc2-Badge.png')"
          ></v-img>

          <v-img
            class="mr-2 d-inline-flex"
            max-width="100"
            max-height="60"
            contain
            :src="require('@assets/images/footer/Secure-SSL-white.svg')"
          ></v-img>
        </div>
      </v-col>
      <v-col md="4" sm="4" xs="12">
        <div class="mb-2 d-inline-flex">
          <v-img
            class="mr-1 d-inline-flex"
            width="100"
            height="40"
            contain
            :src="require('@assets/images/footer/AppStore.png')"
          ></v-img>

          <v-img
            class="d-inline-flex"
            width="100"
            height="40"
            contain
            :src="require('@assets/images/footer/GooglePlay.png')"
          ></v-img>
        </div>
        <div class="mb-2 ml-3">
          <v-img
            class="mr-2 d-inline-flex"
            height="30"
            contain
            :src="require('@assets/images/footer/Facebook-black.svg')"
          ></v-img>

          <v-img
            class="d-inline-flex"
            height="30"
            contain
            :src="require('@assets/images/footer/Instagram-black.svg')"
          ></v-img>
        </div>
        <div class="ml-3"> © 2023 HealthBook+. All rights reserved. </div>
      </v-col>
    </v-row>
  </v-footer>
</template>

<style lang="scss" module>
@import '@design';
.innerContainer {
  width: 100%;
  padding: 20px;
  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0.2px;
}
.footerContainer {
  width: 100%;
  color: white !important;
  background-color: #051957 !important;
}

.shrinkFooterContainer {
  margin-left: 200px;
  color: white !important;
  background-color: #051957 !important;
}
.links a {
  font-weight: 700;
  color: #3193fc !important;
  text-decoration: none;
}

.links {
  width: 40% !important;
  text-align: left !important;
}

@media screen and (max-width: 667px) and (orientation: portrait) {
  .links {
    width: 100% !important;
  }
}

@media screen and (max-width: 667px) and (orientation: landscape) {
  .links {
    width: 80% !important;
  }
}

@media screen and (min-width: 668px) and (max-width: 960px) {
  .links {
    width: 60% !important;
  }
}
</style>
